import React from "react";
import HostedVideoEmbed from "../Common/HostedVideoEmbed.jsx";
import ChatLinkCard from "../Common/ChatLinkCard.jsx";
import { isHostedBookmarkCardLink } from "../../Utils/videoEmbedUrl";
import { CHAT_VIDEO_EMBED_SHELL_STYLE } from "./chatVideoShell.js";
import "../../css/hosted-video-embed.css";

/**
 * Renders pasted video URLs and generic links using the same DOM shell as
 * uploaded file videos (file-icon → span → player).
 */
export default function ChatEmbedMedia({ videoUrls = [], linkUrls = [] }) {
  const videos = Array.isArray(videoUrls) ? videoUrls : [];
  const links = Array.isArray(linkUrls) ? linkUrls : [];

  if (videos.length === 0 && links.length === 0) return null;

  return (
    <div
      className="file-icon d-flex align-items-end flex-column"
      style={{ gap: "8px" }}
    >
      {videos.map((url, i) => (
        <span key={`chat-embed-video-${i}`} className="chat-embed-media-span">
          <div
            className="chat-video-embed-shell"
            style={CHAT_VIDEO_EMBED_SHELL_STYLE}
          >
            <HostedVideoEmbed url={url} />
          </div>
        </span>
      ))}
      {links.map((url, i) => (
        <span key={`chat-embed-link-${i}`} className="chat-embed-media-span">
          <div
            className="chat-video-embed-shell chat-video-embed-shell--link"
            style={CHAT_VIDEO_EMBED_SHELL_STYLE}
          >
            {isHostedBookmarkCardLink(url) ? (
              <HostedVideoEmbed url={url} />
            ) : (
              <ChatLinkCard url={url} />
            )}
          </div>
        </span>
      ))}
      <div className="file-meta">
        <a
          href={videos[0] || links[0] || "#"}
          target="_blank"
          rel="noopener noreferrer"
          className="text-decoration-none"
          style={{ color: "#b3ddff" }}
          aria-hidden="true"
          tabIndex={-1}
        />
      </div>
    </div>
  );
}
